export default __webpack_public_path__ + "menu-orders-icon.7ce6771261234cc2a838f1145659b76d.svg";